export default __webpack_public_path__ + "static/media/sensotrend_connect_welcome.97411d99.png";